import { getStarted_FlexPane_Title } from 'owa-locstrings/lib/strings/getstarted_flexpane_title.locstring.json';
import { whatsNew_FlexPane_Title } from 'owa-locstrings/lib/strings/whatsnew_flexpane_title.locstring.json';
import { timePanelHeaderText } from '../strings.locstring.json';
import { panelHeaderText } from './OwaSuiteFlexPane.locstring.json';
import { settingsCharm_ariaLabel } from 'owa-locstrings/lib/strings/settingscharm_arialabel.locstring.json';
import { helpCharm_ariaLabel } from 'owa-locstrings/lib/strings/helpcharm_arialabel.locstring.json';
import { feedbackCharm_ariaLabel } from 'owa-locstrings/lib/strings/feedbackcharm_arialabel.locstring.json';
import { activityFeedTitle } from 'owa-locstrings/lib/strings/activityfeedtitle.locstring.json';
import loc from 'owa-localize';
/* tslint:disable:jsx-no-lambda WI:47690 */
import * as React from 'react';
import * as ReactDOM from 'react-dom';

import { FeedbackForm } from 'owa-feedback';
import {
    OwaFeedbackButtonID,
    OwaFeatureFlagsButtonID,
    OwaWhatsNewButtonID,
    OwaGetStartedButtonID,
    OwaSettingsButtonID,
    OwaToDoButtonID,
    OwaHelpButtonID,
    OwaTimePanelButtonID,
    OwaActivityFeedButtonID,
} from './OwaSuiteHeaderButton';
import { ShellFlexPane } from '@suiteux/suiteux-shell-react';
import { Fabric } from 'office-ui-fabric-react/lib/Fabric';
import { getActiveCharm, toggleCharm, deactivateCharm, HeaderCharmType } from 'owa-header-store';

import closeFlexPane from 'owa-suite-header-apis/lib/flexpanes/closeFlexPane';
import resetSearch from 'owa-options-search/lib/actions/resetSearch';

import { FeatureFlagsHeader, FeatureFlagsList } from 'owa-header-pane';
import { QuickOptions } from 'owa-options-view';
import { FolderPicker, TodoPanel } from 'owa-todos';
import { TimePanel, TimePanelHeaderBar } from 'owa-time-panel';
import { WhatsNewContainer } from 'owa-whats-new';
import { GetStartedList } from 'owa-get-started';
import { MiniMavenPane } from 'owa-header-pane';
import { WHATSNEW_FLEXPANE_ID, GETSTARTED_FLEXPANE_ID, ACTIVITYFEED_FLEXPANE_ID } from 'owa-header';
import { ActivityFeed } from 'owa-activity-feed';
import popoutReadingPane from 'owa-popout-utils/lib/utils/popoutReadingPane';

const headerStyles = require('./OwaSuiteHeader.scss');
const toDoStyles = require('owa-header-pane/lib/components/TodoPane.scss');
const headerPaneStyles = require('owa-header-pane/lib/components/HeaderPane.scss');
const classNames = require('classnames');

export const OwaFeedbackFlexPane = {
    flexPaneID: 'OwaFeedback',
    flexPaneTitle: () => loc(feedbackCharm_ariaLabel),
    triggerControlID: OwaFeedbackButtonID,
    containerClassName: headerStyles.customFlexPane,
    render: (container: HTMLDivElement) => {
        ReactDOM.render(
            <FeedbackForm
                onSendFeedback={() => {
                    closeFlexPane('OwaFeedback');
                }}
            />,
            container
        );
    },
} as ShellFlexPane;

export const OwaFeatureFlagsFlexPane = {
    flexPaneID: 'OwaFeatureFlags',
    flexPaneTitle: () => 'Feature Flags', // No need to localize as it is a DEV feature only
    triggerControlID: OwaFeatureFlagsButtonID,
    containerClassName: headerStyles.customFlexPane,
    render: renderInsideFlexPane(
        [<FeatureFlagsHeader key="header" />, <FeatureFlagsList key="list" />],
        'Feature Flags'
    ),
} as ShellFlexPane;

const OwaSettingsFlexPaneID = 'OwaSettings';
export const OwaSettingsFlexPane = {
    flexPaneID: OwaSettingsFlexPaneID,
    flexPaneTitle: () => loc(settingsCharm_ariaLabel),
    onFlexPaneClose: resetSearch,
    triggerControlID: OwaSettingsButtonID,
    containerClassName: headerStyles.customFlexPane,
    render: renderInsideFlexPane(
        <QuickOptions onDismiss={onQuickSettingsDismiss} />,
        loc(settingsCharm_ariaLabel)
    ),
} as ShellFlexPane;

export const OwaToDoFlexPane = {
    flexPaneID: 'OwaToDo',
    flexPaneTitle: () => loc(panelHeaderText),
    triggerControlID: OwaToDoButtonID,
    containerClassName: classNames(toDoStyles.todoFlexPaneContent, headerStyles.customFlexPane),
    customTitle: (container: HTMLDivElement) => {
        ReactDOM.render(<FolderPicker />, container);
    },
    render: renderInsideFlexPane(
        <TodoPanel
            hideFolderPicker={true}
            source={'SuiteHeader'}
            closePanel={() => closeFlexPane('OwaToDo')}
        />,
        loc(panelHeaderText),
        toDoStyles.todoFlexPanePanelContainer
    ),
    customEscapeKeyHandling: true,
    onFlexPaneOpen: () => {
        if (getActiveCharm() !== HeaderCharmType.TodoCharm) {
            toggleCharm(HeaderCharmType.TodoCharm);
        }
    },
    onFlexPaneClose: () => deactivateCharm(HeaderCharmType.TodoCharm),
} as ShellFlexPane;

export const OwaTimePanelFlexPane = {
    flexPaneID: 'OwaTimePanel',
    flexPaneTitle: () => loc(timePanelHeaderText),
    triggerControlID: OwaTimePanelButtonID,
    containerClassName: classNames(headerStyles.timePanelContainer, headerStyles.customFlexPane),
    customTitle: (container: HTMLDivElement) => {
        ReactDOM.render(<TimePanelHeaderBar />, container);
    },
    render: renderInsideFlexPane(<TimePanel />, loc(timePanelHeaderText)),
    onFlexPaneOpen: () => {
        if (getActiveCharm() !== HeaderCharmType.TimePanelCharm) {
            toggleCharm(HeaderCharmType.TimePanelCharm);
        }
    },
    onFlexPaneClose: () => deactivateCharm(HeaderCharmType.TimePanelCharm),
} as ShellFlexPane;

export const OwaWhatsNewFlexPane = {
    flexPaneID: WHATSNEW_FLEXPANE_ID,
    flexPaneTitle: () => loc(whatsNew_FlexPane_Title),
    triggerControlID: OwaWhatsNewButtonID,
    containerClassName: headerStyles.customFlexPane,
    onFlexPaneOpen: () => {
        if (getActiveCharm() !== HeaderCharmType.WhatsNewCharm) {
            toggleCharm(HeaderCharmType.WhatsNewCharm);
        }
    },
    onFlexPaneClose: () => deactivateCharm(HeaderCharmType.WhatsNewCharm),
    render: renderInsideFlexPane(<WhatsNewContainer />, loc(whatsNew_FlexPane_Title)),
} as ShellFlexPane;

export const OwaGetStartedFlexPane = {
    flexPaneID: GETSTARTED_FLEXPANE_ID,
    flexPaneTitle: () => loc(getStarted_FlexPane_Title),
    triggerControlID: OwaGetStartedButtonID,
    containerClassName: headerStyles.customFlexPane,
    onFlexPaneOpen: () => {
        if (getActiveCharm() !== HeaderCharmType.GetStartedCharm) {
            toggleCharm(HeaderCharmType.GetStartedCharm);
        }
    },
    onFlexPaneClose: () => deactivateCharm(HeaderCharmType.GetStartedCharm),
    render: renderInsideFlexPane(<GetStartedList />, loc(getStarted_FlexPane_Title)),
} as ShellFlexPane;

const HelpFlexPaneID = 'OwaHelp';
export const OwaHelpFlexPane = {
    flexPaneID: HelpFlexPaneID,
    flexPaneTitle: () => loc(helpCharm_ariaLabel),
    triggerControlID: OwaHelpButtonID,
    containerClassName: headerStyles.customFlexPane,
    onFlexPaneOpen: () => {
        if (getActiveCharm() !== HeaderCharmType.HelpCharm) {
            toggleCharm(HeaderCharmType.HelpCharm);
        }
    },
    onFlexPaneClose: () => deactivateCharm(HeaderCharmType.HelpCharm),
    render: renderInsideFlexPane(
        <MiniMavenPane
            onDismiss={() => {
                closeFlexPane(HelpFlexPaneID);
                deactivateCharm(HeaderCharmType.HelpCharm);
            }}
        />,
        loc(helpCharm_ariaLabel),
        headerPaneStyles.content
    ),
} as ShellFlexPane;

const activityFeedActions = {
    openMail: popoutReadingPane,
};
export const OwaActivityFeedFlexPane = {
    flexPaneID: ACTIVITYFEED_FLEXPANE_ID,
    flexPaneTitle: () => loc(activityFeedTitle),
    triggerControlID: OwaActivityFeedButtonID,
    containerClassName: headerStyles.fullHeightFlexPane,
    onFlexPaneOpen: () => {
        if (getActiveCharm() !== HeaderCharmType.ActivityFeedCharm) {
            toggleCharm(HeaderCharmType.ActivityFeedCharm);
        }
    },
    onFlexPaneClose: () => deactivateCharm(HeaderCharmType.ActivityFeedCharm),
    render: renderInsideFlexPane(
        <ActivityFeed actions={activityFeedActions} />,
        loc(activityFeedTitle)
    ),
} as ShellFlexPane;

function renderInsideFlexPane(
    elements: React.ReactNode | React.ReactNode[],
    flexPaneTitle: string,
    className?: string
) {
    return (container: HTMLDivElement) =>
        ReactDOM.render(
            <Fabric
                tabIndex={-1}
                role={'complementary'}
                aria-label={flexPaneTitle}
                className={className}>
                {elements}
            </Fabric>,
            container
        );
}

function onQuickSettingsDismiss() {
    closeFlexPane(OwaSettingsFlexPaneID);
}
